import React from 'react'

import EditRepForm from '../../modules/Rep/components/EditRepForm'
export default function EditRepPage() {
  return <EditRepForm />
}
